import React from 'react';
import type { SidebarHighlight, Testimonial } from '@/types';
import styles from './Sidebar.module.css';

interface SidebarProps {
  highlights: SidebarHighlight[];
  testimonial: Testimonial;
}

export const Sidebar: React.FC<SidebarProps> = ({ highlights, testimonial }) => {
  return (
    <aside className={styles.sidebar}>
      <h3 className={styles.title}>Profil</h3>
      <ul className={styles.highlightList}>
        {highlights.map((highlight, index) => (
          <li key={index} className={styles.highlightItem}>
            <strong>{highlight.title}</strong>
            <small>{highlight.description}</small>
          </li>
        ))}
      </ul>

      <div className={styles.testimonialBox}>
        <h4 className={styles.testimonialTitle}>Expertutlåtande</h4>
        <p className={styles.testimonialQuote}>{testimonial.quote}</p>
        <small className={styles.testimonialAuthor}>
          — {testimonial.author}, {testimonial.title}
        </small>
      </div>
    </aside>
  );
};
